import React, { FC, useContext } from 'react';
import {
	FormControl,
	FormControlLabel,
	Radio,
	RadioGroup,
	Typography,
	Stack,
	Box,
} from '@mui/material';
import { AutoAwesome } from '@mui/icons-material';
import { DpOutlinedInput } from '@/components/blocks/OutlinedInput';
import { ContentContext } from '@/data/context/content';
import { PERSONALIZATION_OPTIONS, type useProductDetails } from '@/data/Content/ProductDetails';
import { DisclaimerCustomProduct } from '@/components/content/ProductDetails/parts/DisclaimerCustomProduct';

type PDPContext = ReturnType<typeof useProductDetails>;

export const ProductCustomPlayer: FC = () => {
	const {
		isCustomizable,
		customizableState,
		customizableError,
		onChangeCustomizableInput,
		onBlurCustomizableInput,
	} = useContext(ContentContext) as PDPContext;

	if (!isCustomizable) {
		return null;
	}

	return (
		<React.Fragment>
			<Box mb={2}>
				<Stack direction="row" spacing={1} alignItems="center" justifyContent="start" mb={1}>
					<AutoAwesome />
					<Typography
						sx={{
							fontSize: 'var(--font-size-default)',
							fontWeight: 'bold',
							color: '#2C2C2C',
						}}
					>
						{'¡Personalizado!'}
					</Typography>
				</Stack>
				<Typography
					sx={{
						fontSize: 'var(--font-size-default)',
						fontWeight: 'normal',
						color: '#2C2C2C',
						display: 'inline',
					}}
				>
					{'Personaliza tu producto agregando el nombre y número que quieras'}
				</Typography>
			</Box>

			<FormControl fullWidth sx={{ mb: 2 }}>
				<Stack spacing={2}>
					<RadioGroup
						name="option"
						row
						value={customizableState.option}
						onChange={onChangeCustomizableInput}
						sx={{ width: '100%' }}
					>
						<Box
							sx={{
								display: 'flex',
								width: '100%',
								border: '1px solid #ccc',
								borderRadius: '6px',
								overflow: 'hidden',
							}}
						>
							<FormControlLabel
								value={PERSONALIZATION_OPTIONS.CUSTOM}
								control={<Radio />}
								label="Añade el tuyo"
								sx={{
									fontSize: '15px',
									flex: 1,
									m: 0,
									px: 2,
									py: 1,
									borderRight: '1px solid #ccc',
									justifyContent: 'center',
									'& .MuiRadio-root': {
										p: 0.5,
									},
									'&.MuiFormControlLabel-root': {
										backgroundColor:
											customizableState.option === PERSONALIZATION_OPTIONS.CUSTOM
												? '#e6f0ff'
												: 'transparent',
									},
								}}
							/>
							<FormControlLabel
								value={PERSONALIZATION_OPTIONS.DEFAULT}
								control={<Radio />}
								label="Sin personalizar"
								sx={{
									fontSize: '15px',
									flex: 1,
									m: 0,
									px: 2,
									py: 1,
									justifyContent: 'center',
									'& .MuiRadio-root': {
										p: 0.5,
									},
									'&.MuiFormControlLabel-root': {
										backgroundColor:
											customizableState.option === PERSONALIZATION_OPTIONS.DEFAULT
												? '#e6f0ff'
												: 'transparent',
									},
								}}
							/>
						</Box>
					</RadioGroup>
					{customizableState.option === PERSONALIZATION_OPTIONS.CUSTOM ? (
						<Box>
							<Stack spacing={1} direction="row">
								<DpOutlinedInput
									label="Numero"
									value={customizableState.customNumber}
									name="customNumber"
									error={customizableError.customNumber}
									helperText={
										customizableError.customNumber
											? 'Por favor ingresa un número para personalizar tu producto'
											: ''
									}
									sx={{ width: '200px' }}
									type="text"
									inputProps={{ maxLength: 2, inputMode: 'numeric', pattern: '[0-9]*' }}
									onChange={onChangeCustomizableInput}
								/>
								<DpOutlinedInput
									label="Nombre"
									value={customizableState.customName}
									name="customName"
									error={customizableError.customName}
									helperText={
										customizableError.customName
											? 'Por favor ingresa un nombre para personalizar tu producto'
											: ''
									}
									type="text"
									sx={{ flex: 1 }}
									inputProps={{ maxLength: 8 }}
									onChange={onChangeCustomizableInput}
									onBlur={onBlurCustomizableInput}
								/>
							</Stack>
							<DisclaimerCustomProduct />
						</Box>
					) : null}
				</Stack>
			</FormControl>
		</React.Fragment>
	);
};
